<div class="modal-body">
  <app-email-verify #emailVerify [verifier]="email" [email]="email" [forceLogin]="sendVerification" [documentLocale]="documentLocale" (verified)="nextStep($event)"></app-email-verify>

  <div class="centermodal__button-group">
    <button type="button" class="btn-M btn-filled-cancel" [disabled]="isLoading" (click)="modal.dismiss()">{{ 'button.close' | translate }}</button>
    <button type="button" class="btn-M btn-filled" [disabled]="isLoading" (click)="emailVerify.submitToken()">
      {{ 'button.continue' | translate }}
    </button>
  </div>
</div>
